// Internal
import { RootState } from './RootState';

export enum StoreGetters {
  "IsUserAdmin" = "isUserAdmin",
}

export default {
  isUserAdmin(state: RootState) {
    return state.currentUsr &&
      state.currentUsr.roles
        .find((x: string) => x.toLowerCase() == 'admin') != undefined
  },
  // lookupStagioni(state: RootState): string[] {
  //   if(state.datiLookup) {
  //     return state.datiLookup.stagioni.map(x => `${x.id} ${x.desc}`);
  //   }
  //   return [];
  // },
  // lookupModelli(state: RootState): string[] {
  //   if(state.datiLookup) {
  //     return state.datiLookup.modelli.map(x => `${x.id} ${x.desc}`);
  //   }
  //   return [];
  // },
  // lookupFasi(state: RootState): string[] {
  //   if(state.datiLookup) {
  //     return state.datiLookup.fasi.map(x => `${x.id} ${x.desc}`);
  //   }
  //   return [];
  // },
  // lookupConsegne(state: RootState): string[] {
  //   if(state.datiLookup) {
  //     return state.datiLookup.consegne.map(x => `${x.id} ${x.desc}`);
  //   }
  //   return [];
  // }
}
